const testimonials = [
  {
    name: "Maria S.",
    location: "Hollywood Beach, FL",
    rating: 5,
    text: "My mother in Bogota needed emergency surgery and I needed to be there within the week. I pulled out my passport and it had expired four months ago. I was devastated. Fast Passport Center got my renewal processed and shipped back to me in four days. I made my flight to Colombia and spent two weeks with my mother during her recovery. I cannot express how much this meant to my family.",
    service: "Passport Renewal",
  },
  {
    name: "James T.",
    location: "Diplomat Beach area, Hollywood, FL",
    rating: 5,
    text: "We had a Royal Caribbean cruise booked from Port Everglades in five days. My wife and I were walking the Broadwalk the weekend before and my passport fell out of my pocket into a puddle. It was completely water-damaged and unusable. I shipped it to Fast Passport Center Monday morning and had a replacement by Thursday afternoon. We made our cruise embarkation Friday morning with zero issues.",
    service: "Damaged Passport Replacement",
  },
  {
    name: "The Rodriguez Family",
    location: "Young Circle area, Hollywood, FL",
    rating: 5,
    text: "We planned a spring break trip — three nights at a Cancun resort followed by a Disney cruise from Port Canaveral. I checked our passports two weeks before departure and discovered my daughter's passport had expired six months earlier. I had no idea child passports only last five years. Fast Passport Center processed her new passport in four days. We made both legs of our vacation. They explained the child passport rules so clearly — I now set calendar reminders for both my kids.",
    service: "Child Passport",
  },
];

function Stars({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-[#F6C344] text-sm"></i>
      ))}
    </div>
  );
}

export default function HollywoodTestimonialsSection() {
  return (
    <section className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Reviews</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            What Hollywood Travelers Say
          </h2>
          <p className="text-gray-500 max-w-2xl mx-auto text-base leading-relaxed">
            Real reviews from Hollywood Beach, downtown Hollywood, and south Broward County residents who trusted Fast Passport Center with their expedited passports.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white border border-gray-200 rounded-lg p-6 flex flex-col"
            >
              <Stars count={t.rating} />
              <p className="text-gray-600 text-sm leading-relaxed mt-4 flex-1 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div className="mt-5 pt-4 border-t border-gray-200 flex items-center justify-between">
                <div>
                  <p className="font-bold text-[#1A365D] text-sm">{t.name}</p>
                  <p className="text-gray-400 text-xs">{t.location}</p>
                </div>
                <span className="text-xs font-semibold text-[#F6C344] bg-[#F6C344]/10 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}